import { gql } from '@apollo/client'
import { ArrowRightIcon, BodyText, Button, Heading } from '@farol-ds/react'

import { BenefitsList } from '../benefits-list'
import { DoctrineOneOfferLockUnloggedContent_OfferLockDataFragment } from './__generated__/doctrine-one-offer-lock-unlogged-content.graphql'
import styles from './doctrine-one-offer-lock-unlogged-content.module.scss'

export interface DoctrineOneOfferLockUnloggedContentProps {
  offerLockData: DoctrineOneOfferLockUnloggedContent_OfferLockDataFragment
}

export function DoctrineOneOfferLockUnloggedContent({
  offerLockData,
}: DoctrineOneOfferLockUnloggedContentProps) {
  const { body, header } = offerLockData || {}
  const { title = '', subtitle = '' } = header || {}
  const {
    cards: [card],
  } = body || {}

  return (
    <>
      <div className={styles.header}>
        <Heading size="lg">{title}</Heading>
        <BodyText size="md">
          <span dangerouslySetInnerHTML={{ __html: subtitle }} />
        </BodyText>
      </div>

      <div className={styles.card}>
        <BenefitsList offerLockCard={card} />

        <div className={styles.buttons}>
          {card.buttons.map((button, index) => (
            <Button
              key={index}
              kind={button.kind || 'primary'}
              rightIcon={index === card.buttons.length - 1 && <ArrowRightIcon />}
              asChild={!!button.url}
            >
              {button.url ? (
                <a href={button.url} target={index > 0 ? '_blank' : ''} rel="noopener noreferrer">
                  {button.label}
                </a>
              ) : (
                button.label
              )}
            </Button>
          ))}
        </div>
      </div>
    </>
  )
}

DoctrineOneOfferLockUnloggedContent.fragments = {
  offerLockData: gql`
    fragment DoctrineOneOfferLockUnloggedContent_offerLockData on OfferLockData {
      header {
        title
        subtitle
      }
      body {
        cards {
          buttons {
            label
            kind
            url
          }
          ...BenefitsList_offerLockCard
        }
      }
    }

    ${BenefitsList.fragments.offerLockCard}
  `,
}
